/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateWhitelistRequest
 */
export interface UpdateWhitelistRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateWhitelistRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWhitelistRequest
     */
    status: UpdateWhitelistRequestStatusEnum;
}


/**
 * @export
 */
export const UpdateWhitelistRequestStatusEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;
export type UpdateWhitelistRequestStatusEnum = typeof UpdateWhitelistRequestStatusEnum[keyof typeof UpdateWhitelistRequestStatusEnum];


/**
 * Check if a given object implements the UpdateWhitelistRequest interface.
 */
export function instanceOfUpdateWhitelistRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function UpdateWhitelistRequestFromJSON(json: any): UpdateWhitelistRequest {
    return UpdateWhitelistRequestFromJSONTyped(json, false);
}

export function UpdateWhitelistRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateWhitelistRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'status': json['status'],
    };
}

export function UpdateWhitelistRequestToJSON(value?: UpdateWhitelistRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'status': value.status,
    };
}

